import styled from "styled-components";

export const ModalBodyContent = styled.div`  
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

export const FileExplorerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;
  max-height: 490px;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.highClearGray};
  }
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.lighterGray};
    border-radius: 3px;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.colors.lighterGray} ${props => props.theme.colors.highClearGray};
`;

export const FileItemStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  min-height: 44px;
  box-sizing: border-box;
  
  ${(props) => props.$isActive && `
    background-color: #dce6ff;
    border-color: #554eff;
  `}
  
  &:hover {
    ${(props) => !props.$isActive && `
      background-color: ${props.theme.colors.ghostWhite || '#F9FAFB'};
    `}
  }
`;

export const FileItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0; /* Allow text truncation */
  overflow: hidden;
`;

export const FileItemRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-left: 8px;
`;

export const FileName = styled.span`
  color: ${(props) => props.theme.colors.text || '#1a1a1a'};
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/* Accordion-style nested content container */
export const NestedContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 16px;
  padding-left: 12px;
  border-left: 2px solid ${props => props.theme.colors.lightGray || '#E5E7EB'};
  
  /* Remove border for last nested level if too deep */
  ${props => props.$level > 2 && `
    margin-left: 12px;
    padding-left: 8px;
  `}
`;

/* Empty folder message */
export const EmptyFolder = styled.div`
  padding: 8px 12px;
  color: ${props => props.theme.colors.darkGray || '#6B7280'};
  font-size: 13px;
  font-style: italic;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 200px;
`;

/* Loading indicator inside nested content */
export const NestedLoading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: ${props => props.theme.colors.darkGray || '#6B7280'};
  font-size: 13px;
`;

/* Empty state message */
export const EmptyStateMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: ${props => props.theme.colors.darkGray || '#666'};
  font-size: 14px;
`;
